import { toast } from "react-toastify";
import {
  RateLimitRejection,
  describeRateLimitRejection,
} from "./rateLimit";

/**
 * One id for every rate-limit notice in the app.
 *
 * Two things collapse onto it. A single limit usually rejects several in-flight
 * operations at once — a page that fires four queries on mount produces four
 * rejections — and the global Apollo link fires alongside whatever local
 * handling the screen already has. react-toastify drops a toast whose id is
 * already showing, so the user sees the notice once either way.
 */
export const RATE_LIMIT_TOAST_ID = "rate-limit";

/**
 * Announce a rate-limit rejection.
 *
 * Safe to call from anywhere, including outside React — the global Apollo error
 * link is the main caller.
 */
export function notifyRateLimited(rejection: RateLimitRejection): void {
  toast.error(describeRateLimitRejection(rejection), {
    toastId: RATE_LIMIT_TOAST_ID,
  });
}
